module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_ltv-2450a695972768cb1eb1fd226f4ad315.svg";